import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "clear"]
  static values = { searchValue: String }

  connect() {
    this.updateAction()
  }

  updateAction() {
    const showingActiveSearch = this.searchValueValue.length > 0 && this.inputTarget.value === this.searchValueValue

    this.submitTarget.hidden = showingActiveSearch
    this.clearTarget.hidden = !showingActiveSearch
  }
}
